import type { JSX } from 'react';

import { Card } from '@change-corgi/design-system-legacy/components/content';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { PromotionHistory } from './components/PromotionHistory';
import { RecentPromotionsList } from './components/RecentPromotionsList';
import { TopSignatureSources } from './components/TopSignatureSources';
import { usePetitionInsights } from './hooks/usePetitionInsights';

export function PetitionInsights(): JSX.Element | null {
	const { data } = usePetitionInsights();

	if (!data.shouldShowPetitionInsights) return null;

	return (
		<Box as="section" aria-labelledby="petition-insights-title" role="group" data-qa="promotion-insights">
			{data.shouldShowSignatureSources && (
				<Card mt="16px" backgroundColor="white" sx={{ border: 'unset', borderRadius: 'big' }}>
					<TopSignatureSources />
				</Card>
			)}
			{data.shouldShowPromotionStats && (
				<Card mt="16px" backgroundColor="white" sx={{ border: 'unset', borderRadius: 'big' }}>
					<PromotionHistory />
					<RecentPromotionsList />
				</Card>
			)}
		</Box>
	);
}
